import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row w-100" }
const _hoisted_2 = { class: "card-body w-50" }
const _hoisted_3 = { class: "card-body w-50" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "pb-10 pb-lg-12" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder text-dark" }, "Benefits")
], -1)
const _hoisted_5 = { class: "fv-row mb-10" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "List any anticipated direct and societal benefits to participation in this research project. ")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex text-gray-400 align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, " If none, state that fact here and in the consent form ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DropDownSection = _resolveComponent("DropDownSection")!
  const _component_editor = _resolveComponent("editor")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_DropDownSection, {
        title: "Review for more information",
        list: _ctx.listDropDownSections
      }, null, 8, ["list"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _hoisted_7,
        _createVNode(_component_editor, {
          for: "possibleBenefit",
          initialValue: "step2.possibleBenefit",
          modelValue: _ctx.step2.possibleBenefit,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.step2.possibleBenefit) = $event)),
          "api-key": _ctx.currentEditorToken,
          licenseKey: "gpl",
          init: {
            height: 200,
            menubar: false,
            plugins: [
              'advlist autolink lists link image charmap',
              'searchreplace visualblocks code fullscreen',
              'print preview anchor insertdatetime media',
              'paste code help wordcount table',
            ],
            toolbar:
              'undo redo | formatselect | bold italic |         alignleft aligncenter alignright |         bullist numlist outdent indent | help',
          }
        }, null, 8, ["modelValue", "api-key"]),
        _createVNode(_component_Field, {
          type: "hidden",
          name: "possibleBenefit",
          class: "form-control form-control-lg form-control-solid mb-3 mb-lg-0",
          placeholder: "How it will be record?",
          modelValue: _ctx.step2.possibleBenefit,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.step2.possibleBenefit) = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_ErrorMessage, {
          name: "possibleBenefit",
          class: "fv-plugins-message-container invalid-feedback"
        })
      ])
    ])
  ]))
}